var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "a",
      {
        staticClass: "nav-link",
        attrs: { "data-toggle": "dropdown", href: "#" },
      },
      [
        _c("i", { staticClass: "far fa-bell fa-lg" }),
        _vm.notificationCount > 0
          ? _c(
              "span",
              { staticClass: "badge badge-danger notification-count" },
              [_vm._v(_vm._s(_vm.notificationCount))]
            )
          : _vm._e(),
      ]
    ),
    _c(
      "div",
      {
        staticClass:
          "dropdown-menu dropdown-menu-right notification-menu p-0 mt-2",
      },
      [
        _vm.isCurrentRoleResponsible
          ? _c(
              "div",
              [
                _vm._l(
                  _vm.appointmentNotifications,
                  function (notification, index) {
                    return [
                      _c("appointment-responsible-notification", {
                        key: "appointment_notify_" + index,
                        attrs: { notificationData: notification.data },
                      }),
                      _c("div", {
                        key: "appointment_notify_divider_" + index,
                        staticClass: "dropdown-divider m-0",
                      }),
                    ]
                  }
                ),
              ],
              2
            )
          : _c(
              "div",
              [
                _vm._l(
                  _vm.appointmentNotifications,
                  function (notification, index) {
                    return [
                      _c("appointment-employee-notification", {
                        key: "appointment_notify_" + index,
                        attrs: { notificationData: notification.data },
                      }),
                      _c("div", {
                        key: "appointment_notify_divider_" + index,
                        staticClass: "dropdown-divider m-0",
                      }),
                    ]
                  }
                ),
              ],
              2
            ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }